//calls the dog image api and returns a random dog image
async function getDogUrl() {
  const response = await fetch("https://dog.ceo/api/breeds/image/random");
  const message = await response.json();
  const url = message["message"];
  return url;
}

async function getSpecificDog(breed) {
  const fetchURL = "https://dog.ceo/api/breed/" + breed + "/images/random";
  const response = await fetch(fetchURL);
  if (response.ok) {
    const message = await response.json();
    const url = message["message"];
    return url;
  }
}

const dogList = [
  "Affenpinscher",
  "African",
  "Airedale",
  "Akita",
  "Appenzeller",
  "Australian/shepherd",
  "Basenji",
  "Beagle",
  "Bluetick",
  "Borzoi",
  "Bouvier",
  "Boxer",
  "Brabancon",
  "Briard",
  "Buhund/norwegian",
  "Bulldog/boston",
  "Bulldog/english",
  "Bulldog/french",
  "Bullterrier/staffordshire",
  "Cattledog/australian",
  "Chihuahua",
  "Chow",
  "Clumber",
  "Cockapoo",
  "Collie/border",
  "Coonhound",
  "Corgi/cardigan",
  "Cotondetulear",
  "Dachshund",
  "Dalmatian",
  "Dane/great",
  "Deerhound/scottish",
  "Dhole",
  "Dingo",
  "Doberman",
  "Elkhound/norwegian",
  "Entlebucher",
  "Eskimo",
  "Finnish/lapphund",
  "Frise/bichon",
  "Germanshepherd",
  "Greyhound/italian",
  "Groenendael",
  "Havanese",
  "Hound/afghan",
  "Hound/basset",
  "Hound/blood",
  "Hound/english",
  "Hound/ibizan",
  "Hound/plott",
  "Hound/walker",
  "Husky",
  "Keeshond",
  "Kelpie",
  "Komondor",
  "Kuvasz",
  "Labradoodle",
  "Labrador",
  "Leonberg",
  "Lhasa",
  "Malamute",
  "Malinois",
  "Maltese",
  "Mastiff/bull",
  "Mastiff/english",
  "Mastiff/tibetan",
  "Mexicanhairless",
  "Mix",
  "Mountain/bernese",
  "Mountain/swiss",
  "Newfoundland",
  "Otterhound",
  "Ovcharka/caucasian",
  "Papillon",
  "Pekinese",
  "Pembroke",
  "Pinscher/miniature",
  "Pitbull",
  "Pointer/german",
  "Pointer/germanlonghair",
  "Pomeranian",
  "Poodle/miniature",
  "Poodle/standard",
  "Poodle/toy",
  "Pug",
  "Puggle",
  "Pyrenees",
  "Redbone",
  "Retriever/chesapeake",
  "Retriever/curly",
  "Retriever/flatcoated",
  "Retriever/golden",
  "Ridgeback/rhodesian",
  "Rottweiler",
  "Saluki",
  "Samoyed",
  "Schipperke",
  "Schnauzer/giant",
  "Schnauzer/miniature",
  "Setter/english",
  "Setter/gordon",
  "Setter/irish",
  "Sheepdog/english",
  "Sheepdog/shetland",
  "Shiba",
  "Shihtzu",
  "Spaniel/blenheim",
  "Spaniel/brittany",
  "Spaniel/cocker",
  "Spaniel/irish",
  "Spaniel/japanese",
  "Spaniel/sussex",
  "Spaniel/welsh",
  "Springer/english",
  "Stbernard",
  "Terrier/american",
  "Terrier/australian",
  "Terrier/bedlington",
  "Terrier/border",
  "Terrier/cairn",
  "Terrier/dandie",
  "Terrier/fox",
  "Terrier/irish",
  "Terrier/kerryblue",
  "Terrier/lakeland",
  "Terrier/norfolk",
  "Terrier/norwich",
  "Terrier/patterdale",
  "Terrier/russell",
  "Terrier/scottish",
  "Terrier/sealyham",
  "Terrier/silky",
  "Terrier/tibetan",
  "Terrier/toy",
  "Terrier/welsh",
  "Terrier/westhighland",
  "Terrier/wheaten",
  "Terrier/yorkshire",
  "Tervuren",
  "Vizsla",
  "Waterdog/spanish",
  "Weimaraner",
  "Whippet",
  "Wolfhound/irish",
];

export { getDogUrl, getSpecificDog, dogList };
